// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"65254d3a","142":"701d900f","266":"d82813db","283":"081f3789","397":"cab0fc09","400":"57e71efd","588":"169a6b58","646":"8d4a6938","760":"d78bcb10","814":"097a157e","924":"d80cb3de","988":"854d26a8"}[chunkId] + ".chunk.js";
};